import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { CampanhaClienteVisualizacaoModoComponent } from './campanha-cliente-visualizacao-modo.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        CampanhaClienteVisualizacaoModoComponent
    ],
    exports: [
        CampanhaClienteVisualizacaoModoComponent
    ]
})
export class CampanhaClienteVisualizacaoModoModule { }
